import { BULK_MEDIUM_SCOPES } from 'features/ManageCampaigns/utils/inviteBulkMediumHelpers'
import { getTemplate, resolveEditorTemplateKey } from 'features/EmailEditor/templates'
import { resolveStoredShellTemplateKey } from 'features/EmailEditor/utils'

const SCOPE_TEMPLATE_NAME_MATCHERS = {
  [BULK_MEDIUM_SCOPES.all]: name => /^(default|all)\b/i.test(name),
  [BULK_MEDIUM_SCOPES.ota]: name => /\bota\b/i.test(name),
  [BULK_MEDIUM_SCOPES.direct]: name => /\bdirect\b/i.test(name)
}

export function resolveInviteEmailDesignTemplateForScope(templates, scope) {
  if (!templates?.length) {
    return null
  }

  const activeTemplate = templates.find(template => template.isActive)
  const matcher = SCOPE_TEMPLATE_NAME_MATCHERS[scope]
  const scopedTemplate = matcher
    ? templates.find(template => matcher(template.name || ''))
    : null

  return scopedTemplate || activeTemplate || templates[0]
}

export function buildInviteEmailDesignEditPath(templateId) {
  if (!templateId) {
    return '/marketing-assets/email-templates'
  }

  return `/marketing-assets/email-templates/${templateId}`
}

export function resolveInviteEmailDesignLayoutLabel(emailData) {
  if (!emailData) {
    return ''
  }

  const shellTemplateKey =
    resolveStoredShellTemplateKey(emailData.emailParams) || emailData.shellTemplateKey

  if (!shellTemplateKey) {
    return ''
  }

  return getTemplate(resolveEditorTemplateKey(shellTemplateKey)).name
}
